import React from 'react';
import {Form, Switch, Upload, Input, Tooltip, Icon, Select, Row, Col, Button} from 'antd';
import {uploadNotificationImage} from '../../modules/Api';
import {END_POINT} from '../../constants/config';
import history from '../../modules/History';

const FormItem = Form.Item;
// const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class NotificationForm extends React.Component {
    constructor() {
        super();
        this.state = {
            icon: null,
            is_pre_publish: true,
            banner: null,
        }
    }
    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.logo && this.state.icon === null) {
            this.setState({icon: nextProps.initialData.logo});
        }
        if (nextProps.initialData.banner && this.state.banner === null) {
            this.setState({banner: nextProps.initialData.banner});
        }
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                banner: this.state.banner ,icon: this.state.icon}));
        })
    }

    setIsPrePublish = status => {
        this.props.form.setFieldsValue({
            is_pre_publish: status,
        });

        this.setState({is_pre_publish: status});
    }

    get isPrePublish() {
        var is = this.props.form.getFieldValue('is_pre_publish');
        return is;
    }

    render() {
        let img = '';
        if(this.state.icon != null) {
            img = <img src={`${this.state.icon.includes('http') ? this.state.icon : END_POINT + this.state.icon}`} style={{width: '50px', height: '50px', margin: '10px'}} alt="لوگو رویداد"/>;
        }
        let banner = '';
        if(this.state.banner != null) {
            banner = <img src={`${this.state.banner.includes('http') ? this.state.banner : END_POINT + this.state.banner}`} style={{width: '172px', height: '110px', margin: '10px'}} alt="بنر رویداد"/>;
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={10} offset={1}>

                            <FormItem
                                {...formItemLayout}
                                label="آیکن"
                                extra="بهتر است فایل انتخابی مربعی و حداقل عرض 64 پیکسل و فرمت jpg باشد."
                                colon={false}>
                                {getFieldDecorator('uploadNotificationIcon', {
                                    valuePropName: 'fileListLogo',
                                    getValueFromEvent: this.normFileLogo,
                                })(
                                    <Upload
                                        name="icon"
                                        action=""
                                        customRequest={() => {}}
                                        onChange={f => {uploadNotificationImage(f, (src) => {this.setState({icon: src})}, "notification_icon")}}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {img}
                                    </Upload>
                                )}
                            </FormItem>


                            <FormItem
                                {...formItemLayout}
                                label="بنر"
                                extra="بهتر است از پسوند jpeg استفاده شود. ابعاد ( 512x256 الی 1440x720 )"
                                colon={false}>
                                {getFieldDecorator('uploadNotificationImage', {
                                    valuePropName: 'fileListBanner',
                                    getValueFromEvent: this.normFileBanner,
                                })(
                                    <Upload
                                        name="banner"
                                        action=""
                                        customRequest={() => {}}
                                        onChange={f => {uploadNotificationImage(f, (src) => {this.setState({banner: src})})}}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {banner}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="عنوان"
                                colon={false}>
                                {getFieldDecorator('title', {
                                    initialValue: this.props.initialData.title,
                                    rules: [{
                                        required: true, message: 'عنوان پوش را وارد نمایید',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="لینک منبع"
                                direction="ltr"
                                extra="اگر فیلد بالا خالی باشد صفحه اصلی اپ باز میشود در غیر این صورت لینک مورد نظر باز میشود"
                                colon={false}>
                                {getFieldDecorator('url', {
                                    initialValue: this.props.initialData.url,
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="پیش نویس است؟"
                                colon={false}>
                                {getFieldDecorator('is_pre_publish', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.is_pre_publish ? 1 : 0
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsPrePublish}/>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="پلت فرم انتشار"
                                colon={false}>
                                {getFieldDecorator('platform', {
                                    initialValue: this.props.initialData.platform,
                                    rules: [],
                                })(
                                    <Select placeholder="پلت فرم انتشار را انتخاب نمایید..." style={{width: '200px'}}>
                                        <Select.Option value="0">همه</Select.Option>
                                        <Select.Option value="1">مرورگر</Select.Option>
                                        <Select.Option value="2">اپلیکیشن</Select.Option>
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="توضیحات"
                                colon={false}>
                                {getFieldDecorator('content', {
                                    initialValue: this.props.initialData.content,
                                    rules: [{
                                        required: true, message: 'توضیحات را وارد نمایید!',
                                    }],
                                })(
                                    <Input.TextArea/>
                                )}
                            </FormItem>

                        </Col>


                    </Row>
                    <FormItem>
                        <div class="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>

                            {
                                this.props.initialData.id &&
                                <Button type="secondary" onClick={() => history.item.push(`/history/event/${this.props.initialData.id}`)}>تاریخچه تغییرات</Button>
                            }
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}

NotificationForm.defaultProps = {
    initialData: {}
}

export default Form.create()(NotificationForm);


// WEBPACK FOOTER //
// ./src/containers/Notification/form.js